import React, { useEffect, useState } from "react";
import { CircleNotch, TrendUp, Scales, Wallet, ChartLineUp } from "@phosphor-icons/react";
import { api } from "@/lib/api";

const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export default function Dashboard({ cid }) {
  const [r, setR] = useState(null); const [loading, setLoading] = useState(true);
  useEffect(() => { (async () => { setLoading(true); try { setR((await api.get(`/acc/${cid}/ratios`)).data); } catch (e) { console.error(e); } setLoading(false); })(); }, [cid]);

  if (loading) return <CircleNotch size={24} className="animate-spin text-[#F29A86]" />;
  if (!r) return <p className="text-sm text-[#8C8381]">No data yet. Post some vouchers to see your financial dashboard.</p>;

  const cards = [
    { label: "Sales", value: inr(r.sales), icon: TrendUp, sub: `GP ${r.gross_profit_pct}% · NP ${r.net_profit_pct}%` },
    { label: "Net Profit", value: inr(r.net_profit), icon: ChartLineUp, sub: `Gross Profit ${inr(r.gross_profit)}` },
    { label: "Working Capital", value: inr(r.working_capital), icon: Wallet, sub: `CA ${inr(r.current_assets)} · CL ${inr(r.current_liabilities)}` },
    { label: "Capital & Reserves", value: inr(r.capital), icon: Scales, sub: `Debt ${inr(r.debt)}` },
  ];
  const ratios = [
    { label: "Current Ratio", value: r.current_ratio, good: r.current_ratio >= 1.33 },
    { label: "Quick Ratio", value: r.quick_ratio, good: r.quick_ratio >= 1 },
    { label: "Gross Profit %", value: r.gross_profit_pct + "%", good: r.gross_profit_pct > 0 },
    { label: "Net Profit %", value: r.net_profit_pct + "%", good: r.net_profit_pct > 0 },
    { label: "Debt / Equity", value: r.debt_equity, good: r.debt_equity <= 2 },
  ];

  return (
    <div data-testid="acc-dashboard">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {cards.map((c) => { const Icon = c.icon; return (
          <div key={c.label} className="bg-white border border-[#2A2625]/10 rounded-2xl p-5" data-testid={`stat-${c.label.replace(/\s+/g, "-").toLowerCase()}`}>
            <div className="flex items-center gap-2 text-[#8C8381] text-xs mb-2"><Icon size={16} weight="duotone" className="text-[#F29A86]" /> {c.label}</div>
            <div className="text-2xl font-semibold text-[#2A2625]" style={{ fontFamily: "Outfit, sans-serif" }}>{c.value}</div>
            <div className="text-xs text-[#8C8381] mt-1">{c.sub}</div>
          </div>
        ); })}
      </div>
      <h4 className="font-semibold text-[#2A2625] mb-3">Key Financial Ratios</h4>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {ratios.map((rt) => (
          <div key={rt.label} className="bg-white border border-[#2A2625]/10 rounded-2xl p-4 text-center" data-testid={`ratio-${rt.label.replace(/[\s%/]+/g, "-").toLowerCase()}`}>
            <div className={`text-xl font-semibold ${rt.good ? "text-emerald-600" : "text-[#E09494]"}`}>{rt.value}</div>
            <div className="text-xs text-[#8C8381] mt-1">{rt.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
